export default "__VITE_ASSET__7a9f97ac__"